import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import WelcomeScreen from './screens/onboarding/WelcomeScreen';
import UserTypeScreen from './screens/onboarding/UserTypeScreen';
import PrepareScreen from './screens/onboarding/PrepareScreen';
import PhoneScreen from './screens/onboarding/PhoneScreen';
import OtpScreen from './screens/onboarding/OtpScreen';
import DataFormScreen from './screens/onboarding/DataFormScreen';
import LivenessScreen from './screens/onboarding/LivenessScreen';
import SignatureScreen from './screens/onboarding/SignatureScreen';
import ReviewScreen from './screens/onboarding/ReviewScreen';
import SuccessScreen from './screens/onboarding/SuccessScreen';

import LoginScreen from './screens/app/LoginScreen';
import ActivateScreen from './screens/app/ActivateScreen';
import DashboardScreen from './screens/app/DashboardScreen';
import ProfileScreen from './screens/app/ProfileScreen';
import CertificateScreen from './screens/app/CertificateScreen';
import SpecimenScreen from './screens/app/SpecimenScreen';

import NotFoundScreen from './screens/NotFoundScreen';
import { ProtectedRoute, PublicOnlyRoute } from './components/RouteGuards';
import { useAuthStore } from './lib/auth-store';
import { me } from './lib/auth-api';
import { AxiosError } from 'axios';

export default function App() {
    const setAuth = useAuthStore((s) => s.setAuth);
    const clearAuth = useAuthStore((s) => s.clearAuth);

    // Bootstrap: cek session Laravel → isi auth store.
    // 401 → biarkan booting false + isAuthenticated false (public route bisa jalan).
    useEffect(() => {
        me()
            .then((data) => setAuth(data.user, data.registration))
            .catch((e: AxiosError) => {
                if (e.response?.status === 401) {
                    clearAuth();
                } else {
                    clearAuth();
                }
            });
    }, [setAuth, clearAuth]);

    return (
        <Routes>
            <Route path="/" element={<Navigate to="/onboarding/welcome" replace />} />

            {/* Onboarding flow (anon) */}
            <Route path="/onboarding">
                <Route index element={<Navigate to="welcome" replace />} />
                <Route path="welcome" element={<WelcomeScreen />} />
                <Route path="user-type" element={<UserTypeScreen />} />
                <Route path="prepare" element={<PrepareScreen />} />
                <Route path="phone" element={<PhoneScreen />} />
                <Route path="otp" element={<OtpScreen />} />
                <Route path="data-form" element={<DataFormScreen />} />
                <Route path="liveness" element={<LivenessScreen />} />
                <Route path="signature" element={<SignatureScreen />} />
                <Route path="review" element={<ReviewScreen />} />
                <Route path="success" element={<SuccessScreen />} />
            </Route>

            {/* Authenticated user portal */}
            <Route path="/app">
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route
                    path="login"
                    element={
                        <PublicOnlyRoute>
                            <LoginScreen />
                        </PublicOnlyRoute>
                    }
                />
                <Route
                    path="activate"
                    element={
                        <PublicOnlyRoute>
                            <ActivateScreen />
                        </PublicOnlyRoute>
                    }
                />
                <Route
                    path="dashboard"
                    element={
                        <ProtectedRoute>
                            <DashboardScreen />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="profile"
                    element={
                        <ProtectedRoute>
                            <ProfileScreen />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="certificate"
                    element={
                        <ProtectedRoute>
                            <CertificateScreen />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="specimen"
                    element={
                        <ProtectedRoute>
                            <SpecimenScreen />
                        </ProtectedRoute>
                    }
                />
            </Route>

            <Route path="*" element={<NotFoundScreen />} />
        </Routes>
    );
}
